import * as Utils from '../utils/Utils';
import { ApiRequest } from './helper';

export async function list(a) {
  try {
    var parameters = [];

    if (!Utils.isUndefinedOrNull(a.subsidiaryId)) parameters.push('subsidiary_id=' + a.subsidiaryId);

    if (!Utils.isUndefinedOrNull(a.serviceTypeId)) parameters.push('service_type_id=' + a.serviceTypeId);

    if (!Utils.isUndefinedOrNull(a.servicePartnerId)) parameters.push('partner_id=' + a.servicePartnerId);

    if (!Utils.isUndefinedOrNull(a.serviceOriginId)) parameters.push('origin_id=' + a.serviceOriginId);

    if (!Utils.isUndefinedOrNull(a.workerId)) parameters.push('improxy_worker_id=' + a.workerId);

    if (!Utils.isUndefinedOrNull(a.recordsPerPage)) parameters.push('records_per_page=' + a.recordsPerPage);

    if (!Utils.isUndefinedOrNull(a.page)) parameters.push('page=' + a.page);

    const response = await ApiRequest(
      'GET',
      null,
      `${process.env.REACT_APP_API_URL}/api/ServicesPlus/Forms/Logs${
        parameters.length > 0 ? '?' + parameters.join('&') : ''
      }`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}

export async function save(a) {
  try {
    const response = await ApiRequest(
      'POST',
      JSON.stringify(a.data),
      `${process.env.REACT_APP_API_URL}/api/ServicesPlus/Forms/Logs`
    );

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}
